import $ from 'jquery';

export function initZelftest() {

    var $container = $(".plugin-scan");

    $container.scanManager();
    $container.on("rendered", function (e, state) {

        $container.find(".form-check").on("click", function () {
            var $this = $(this);
            var checked = !$this.hasClass('check');
            $this.toggleClass("check", checked);
            $this.find("input").prop('checked', checked);
            $("#formControlRange").prop("disabled", checked);
            $this.parents("article").toggleClass("disable", checked);
        });


        if (state.current_chapter != -1 && state.current_question != -1) {
            $container.find("ul.chapters li:eq(" + state.current_chapter + ")").addClass("active");
            $container.find("ul.steps li:eq(" + state.current_question + ")").addClass("active");
        }
        if (state.question_type == 'option') {
            if (state.current_answer.length) {
                var ar = state.current_answer.split(",");
                for (var i = 0; i <= ar.length; i++) {
                    $("input[name='answer'][value='" + ar[i] + "']").attr("checked", "checked").parent().addClass("check");
                }
            }
        } else if (state.question_type == 'persona_select') {
            $("input[name='answer'][value='" + state.current_answer + "']").attr("checked", "checked");
            if ($("input[name='answer'][value='" + state.current_answer + "']").length > 0) $container.find(".next-question").removeClass("disabled");
        } else {

            if (state.current_answer == -1) {
                $("input[name='not_applicable']").trigger("click");
                $("#formControlRange").prop("disabled", true);
            } else {
                $("input[name='not_applicable']").prop("checked", false);
                $("#formControlRange").prop("value", state.current_answer);
            }

        }

        $container.find(".form-control-range").on("singleTap", function (e, touch) {
            const offset = $(touch.el).offset();
            const width = $(touch.el).width();
            if (offset && width && !$(touch.el).prop("disabled")) {
                touch.el.val(Math.round((touch.x1 - offset.left) / width * 100));
            }
        });

        if ($container.find(".extra-question").length > 0) {
            $("article ul.steps").hide();
        }


        $container.find(".zmp-next-btn.end-result").off("click");
        $container.find(".zmp-next-btn.end-result").on("click", function (e) {
            e.preventDefault();
            location.reload();
        });

        $container.find(".zmp-next-btn.persona_scan-extra-question").off("click");
        $container.find(".zmp-next-btn.persona_scan-extra-question").on("click", function (e) {
            if (undefined === $("input[name='answer']:checked").val()) {
                return false;
            } else {
                return true;
            }
        });

        var enableNextQuestion = function () {
            $container.find(".next-question").removeClass("disabled");
        };

        $container.find(".form-control-radio").off("click", enableNextQuestion);
        $container.find(".form-control-radio").on("click", enableNextQuestion);

        $container.find(".next-question").off("click");
        $container.find(".next-question").on("click", function (e) {
            e.preventDefault();
            var answer;
            if ($("input[name='answer']").attr("data-answer_type") == "option") {
                answer = [];

                $.each($("input[name='answer']:checked"), function () {

                    answer.push($(this).val());

                });
                answer = answer.join(",");

            } else if ($("input[name='answer']").attr("data-answer_type") == "persona_select") {

                const notApplicable = $("input[name='not_applicable']").prop('checked');
                const value: any = $("input[name='answer']:checked").val();

                answer = notApplicable ? -1 : parseInt(value);

                if (undefined === value) {

                    return;
                }
            } else {

                const value: any = $("input[name='answer']").val();

                answer = $("input[name='not_applicable']").prop('checked') ? -1 : parseInt(value);
            }

            $container.scanManager("answerQuestion", answer);
        });

        $container.find(".next-chapter").off("click");
        $container.find(".next-chapter").on("click", function (e) {
            e.preventDefault();
            $container.scanManager("nextQuestion");
        });

        $container.find(".previous-question").off("click");
        $container.find(".previous-question").on("click", function (e) {
            e.preventDefault();
            $container.scanManager("previousQuestion");
        });

        $("html,body").scrollTo($(".plugin-scan main"), 200);
    });

    $(".self-scan-report .btn-mail-self-report").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);

        $this.addClass("d-none");

        $(".notify-sending-email").removeClass("d-none");

        $.ajax({
            url: $this.attr("href"), method: "POST", data: {}, dataType: "json", success: function (data) {

                $(".notify-sending-email").addClass("d-none");

                if (typeof data.success != 'undefined' && data.success) {
                    $(".self-scan-report .mail-result .feedback").removeClass("d-none");
                } else {
                    $this.removeClass("d-none");
                    $(".self-scan-report .mail-result .error").removeClass("d-none");
                }

            }
        });

    });
}
